<template>
  <section>
    <Feature :title="$t('QUOTATION_HISTORY_REPORT')" :iconClass="'fa-history'">
      <FormRowTwo :fieldNameArr="[$t('FUNCTION') + ': ', $t('VENDOR') + ': ', $t('DELTA_PN') + ': ', $t('VENDOR_PN') + ': ']"
        :fieldWidthArr="[364, 364, 364, 364]" :fieldSpanWidthArr="[102, 102, 102, 102]">
        <RadioGroup class="Input" v-model="rfqType" size="large" slot="a">
          <Radio label="COMPONENT">{{ $t('QUOTATION') }}</Radio>
          <Radio label="TOOLING">{{ $t('TOOLING') }}</Radio>
          <Radio label="RFQ">{{ $t('RFQ') }}</Radio>
        </RadioGroup>
        <Input class="Input" v-model="vendorCode" search :enter-button="$t('MORE')" @on-search="moreVendorCode" slot="b" />
        <Input class="Input" v-model="partNo" search :enter-button="$t('MORE')" @on-search="moreDeltaPn" slot="c" />
        <Input class="Input" v-model="vendorPn" search :enter-button="$t('MORE')" @on-search="moreVendorPn" slot="d" />
      </FormRowTwo>
      <FormRowTwo :fieldNameArr="[$t('QUOTE_DATE'), '~', $t('APPROVE_DATE'), '~']"
        :fieldWidthArr="[364, 279, 364, 279]" :fieldSpanWidthArr="[102, 17, 102, 17]">>
        <DatePicker class="Input" v-model="fromQuoteDate" type="date" format="yyyy-MM-dd" :placeholder="$t('VALID_FROM')" slot="a">
        </DatePicker>
        <DatePicker class="Input" v-model="toQuoteDate" type="date" format="yyyy-MM-dd" :placeholder="$t('VALID_TO')" slot="b">
        </DatePicker>
        <DatePicker class="Input" v-model="approveFromDate" type="date" format="yyyy-MM-dd" :placeholder="$t('VALID_FROM')" slot="c">
        </DatePicker>
        <DatePicker class="Input" v-model="approveToDate" type="date" format="yyyy-MM-dd" :placeholder="$t('VALID_TO')" slot="d">
        </DatePicker>
      </FormRowTwo>
      <FormRowTwo :fieldNameArr="[$t('CATEGORY')]"  v-if="showCategory"
        :fieldWidthArr="[364]" :fieldSpanWidthArr="[102]">
        <Select class="Select" v-model="category" :placeholder="$t('CHOOSE')" slot="a">
          <Option v-for="(item) in categorys" :value="item.key" :key="item.key">
            {{ item.value }}
          </Option>
        </Select>
      </FormRowTwo>
      <ButtonRow>
        <Button type="success" @click="search($event, true)" slot="0">{{ $t('COMMON_TEXT_SEARCH') }}</Button>
        <Button type="info" @click="clear" slot="1">{{ $t('CLEAR_SELECT') }}</Button>
      </ButtonRow>
    </Feature>
    <Feature v-show="existedQuotationList" :title="'Data'" :iconClass="'fa-pencil-square-o'">
      <Button type="primary" @click="download">{{ $t('DOWNLOAD') }}</Button>
      <TablePage v-if="rfqType == 'COMPONENT'" :tableWidth="windowWidth" :columnsList="quotationColumnList"
        :resultList="quotationList" :pageObj="pageObj" @changePage="changePage"></TablePage>
      <TablePage v-if="rfqType == 'TOOLING'" :tableWidth="windowWidth" :columnsList="toolingQuotationColumnList"
        :resultList="quotationList" :pageObj="pageObj" @changePage="changePage"></TablePage>
    </Feature>
    <Feature v-show="existedQuotationGroupList" :title="'Data'" :iconClass="'fa-pencil-square-o'">
      <TablePage :tableWidth="windowWidth" :columnsList="quotationGroupColumnList" :resultList="quotationGroupList"
        :pageObj="groupPageObj" @changePage="changeGroupPage"></TablePage>
    </Feature>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" v-model="deltaPnModel"
      :title="$t('DELTA_PN_MORE')" @on-ok="confirmDeltaPnModel">
      <Input v-model="deltaPnValue" type="textarea" :rows="10" />
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" v-model="vendorPnModel"
      :title="$t('VENDOR_PN_MORE')" @on-ok="confirmVendorPnValue">
      <Input v-model="vendorPnValue" type="textarea" :rows="10" />
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" v-model="vendorCodeModel"
      :title="$t('VENDOR_CODE_MORE')" @on-ok="confirmVendorCodeValue">
      <Input v-model="vendorCodeValue" type="textarea" :rows="10" />
    </Modal>

    <Modal :z-index="modalSize" :reset-drag-position="true" width="1300" sticky :draggable="true" v-model="toolingModel"
      :title="$t('TOOLING_ATTRIBUTES')">
      <ReportToolingCompoment :quotation="quotation" :tooling="tooling" :rfqType="rfqType"
        :plmQuotationDocuments="plmQuotationDocuments" :cpcToSupplierReferenceFiles="cpcToSupplierReferenceFiles"
        :toolingQuotationType="toolingQuotationType" :showSupplierQuotationFiles="showSupplierQuotationFiles">
      </ReportToolingCompoment>
    </Modal>

    <Modal :z-index="modalSize" :reset-drag-position="true" width="1300" sticky :draggable="true" v-model="quotationModel"
      :title="$t('QUOTATION')">
      <ReportOtherCompoment :quotation="quotation" :rfqType="rfqType" :plmQuotationDocuments="plmQuotationDocuments"
        :cpcToSupplierReferenceFiles="cpcToSupplierReferenceFiles" :scalePriceList="scalePriceList"
        :showSupplierQuotationFiles="showSupplierQuotationFiles">
      </ReportOtherCompoment>
    </Modal>

    <Modal :z-index="modalSize" :reset-drag-position="true" width="1300" sticky :draggable="true"
      v-model="quotationMetalModel" :title="$t('QUOTATION')">
      <ReportMetalCompoment :quotation="quotation" :metalQuotation="metalQuotation" :priceList="priceList"
        :rfqType="rfqType" :plmQuotationDocuments="plmQuotationDocuments"
        :cpcToSupplierReferenceFiles="cpcToSupplierReferenceFiles" :scalePriceList="scalePriceList"
        :showSupplierQuotationFiles="showSupplierQuotationFiles">
      </ReportMetalCompoment>
    </Modal>

    <Modal :z-index="modalSize" :reset-drag-position="true" width="1300" sticky :draggable="true"
      v-model="quotationPlasticModel" :title="$t('QUOTATION')">
      <ReportPlasticCompoment :quotation="quotation" :plasticQuotation="plasticQuotation" :priceList="priceList"
        :rfqType="rfqType" :plmQuotationDocuments="plmQuotationDocuments"
        :cpcToSupplierReferenceFiles="cpcToSupplierReferenceFiles" :scalePriceList="scalePriceList"
        :showSupplierQuotationFiles="showSupplierQuotationFiles"></ReportPlasticCompoment>
    </Modal>

    <Modal :z-index="modalSize" :reset-drag-position="true" width="1300" sticky :draggable="true"
      v-model="quotationPwbModel" :title="$t('QUOTATION')">
      <ReportPwbCompoment :quotation="quotation" :pwbQuotation="pwbQuotation" :priceList="priceList" :rfqType="rfqType"
        :plmQuotationDocuments="plmQuotationDocuments" :cpcToSupplierReferenceFiles="cpcToSupplierReferenceFiles"
        :scalePriceList="scalePriceList" :showSupplierQuotationFiles="showSupplierQuotationFiles">
      </ReportPwbCompoment>
    </Modal>
  </section>
</template>

<script>
import { mapGetters } from "vuex"
import { mapActions } from "vuex"
import { Translate } from "@/util/common"
import moment from "moment"
import { FileSchemaList } from "@/util/tableTitle"
import ReportOtherCompoment from "@/views/quotation/ReportOtherCompoment"
import ReportToolingCompoment from "@/views/quotation/ReportToolingCompoment"
import ReportMetalCompoment from '@/views/quotation/ReportMetalCompoment'
import ReportPlasticCompoment from '@/views/quotation/ReportPlasticCompoment'
import ReportPwbCompoment from '@/views/quotation/ReportPwbCompoment'
import FormRowTwo from '@/components/FormRowTwo'

export default {
  name: "HistoryReport",
  components: {
    ReportOtherCompoment,
    ReportToolingCompoment,
    ReportMetalCompoment,
    ReportPlasticCompoment,
    ReportPwbCompoment,
    FormRowTwo
  },
  created() {
    this.clear()
  },
  data() {
    return {
      fileSchemaList: FileSchemaList(this),
      pageObj: {
        "page": 0,
        "totalPage": 0,
        "totalCount": 0,
        "pageSize": 20
      },
      groupPageObj: {
        "page": 0,
        "totalPage": 0,
        "totalCount": 0,
        "pageSize": 20
      },
      categorys: [
        {
          key: "ALL",
          value: "All",
        },
        {
          key: "OTHERS",
          value: 'Others'
        }, {
          key: "PWB",
          value: "PWB",
        }, {
          key: "METAL",
          value: 'Metal Case'
        }, {
          key: "PLASTIC",
          value: 'Plastic Case'
        }
      ],
      quotationMetalModel: false,
      metalQuotation: {
        length: '',
        width: '',
        height: '',
        weight: '',
        rawMaterialType: {
          partNo: '',
          partNoDesc: ''
        },
        rmVendor: {
          vendorCode: ''
        },
        coilCenter: {
          vendorCode: ''
        },
        rmPrice: '',
        rmPriceDate: '',
        rmCost: '',
        processingCost: '',
        treatmentCost: '',
        accessoriesCost: '',
        others: '',
        rmRatio: '',
        totalCost: '',
        supplierRemark: ''
      },
      quotationPlasticModel: false,
      plasticQuotation: {
        length: '',
        width: '',
        height: '',
        weight: '',
        model: '',
        resinType: {
          type: ''
        },
        resinVendor: {
          vendorCode: ''
        },
        resinNo: {
          partNo: '',
          partNoDesc: ''
        },
        distributor: {
          vendorCode: ''
        },
        resinColor: '',
        colorNo: '',
        rmPrice: '',
        rmPriceDate: '',
        dyeCost: '',
        cavity: '',
        tannage: '',
        hourlyRate: '',
        cycleTime: '',
        rmCost: '',
        injectingCost: '',
        processingCost: '',
        treatmentCost: '',
        accessoriesCost: '',
        others: '',
        rmRatio: '',
        totalCost: '',
        supplierRemark: ''
      },
      quotationPwbModel: false,
      pwbQuotation: {
        deltaExchangeRate: "",
        cpcExchangeRate: "",
        rfqBase: "",
        cclLaminateType: "",
        layer: "",
        pcbThickness: "",
        internalCoreThickness: "",
        tg: "",
        externalCopperThickness: "",
        internalCopperThickness: "",
        mainSourceCclSupplier: {
          vendorCode: ""
        },
        mainSourceCclShare: 0,
        mainCoreUlNumber: {
          partNoDesc: ""
        },
        mainCoreUP: "",
        secondSourceCclSupplier: {
          vendorCode: ""
        },
        secondCoreUlNumber: {
          partNoDesc: ""
        },
        secondCoreUP: "",
        pcbPrice: "",
        panelLength: "",
        panelWidth: "",
        pnLength: "",
        pnWidth: "",
        area: "",
        pnArea: "",
        supplierSheetSize: "",
        deltaSheetSize: "",
        panelSheet: "",
        pnInSheet: "",
        pnInPanel: "",
        pnUtilization: "",
        panelUtilization: "",
        combineRatio: "",
        numberOfDrill: "",
        slotLength: "",
        goldArea: "",
        materialCost: "",
        surfaceFinishCost: "",
        processCost: "",
        specialCostDown: "",
        deltaPnPriceUsd: "",
        deltaPnPrice: "",
        supplierRemark: ""
      },
      priceList: [],
      formNo: '',
      uuid: '',
      deltaPnValue: '',
      vendorPnValue: '',
      vendorCodeValue: '',
      deltaPnModel: false,
      vendorPnModel: false,
      vendorCodeModel: false,
      toolingModel: false,
      tooling: {},
      quotationModel: false,
      quotation: {},
      supplierQuotationFiles: [],
      showSupplierQuotationFiles: [],
      plmQuotationDocuments: [],
      cpcToSupplierReferenceFiles: [],
      scalePriceList: [],
      toolingQuotationType: '',
      quotationList: [],
      quotationGroupList: [],
      quotationColumnList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t('FORM_NO')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 160,
          align: "center",
          render: (h, params) => {
            if (!params.row.category) {
              return h("span", {}, params.row.formNo)
            } else {
              return h("a", {
                attrs: { style: "color:#46A3FF" },
                on: {
                  click: () => {
                    this.uuid = params.row.uuid
                    this.formNo = params.row.formNo
                    this.toggleLoading(true)
                    if (params.row.category == "OTHERS" || params.row.category == "") {
                      this.$searchSupplierOthers(this).then(vueInstance => {
                        vueInstance.quotationModel = true
                        vueInstance.toggleLoading(false)
                      })
                    }
                    if (params.row.category == "PWB") {
                      this.$searchSupplierPwb(this).then(vueInstance => {
                        vueInstance.quotationPwbModel = true
                        vueInstance.toggleLoading(false)
                      })
                    }
                    if (params.row.category == "METAL") {
                      this.$searchSupplierMetal(this, true).then(vueInstance => {
                        vueInstance.quotationMetalModel = true
                        vueInstance.toggleLoading(false)
                      })
                    }
                    if (params.row.category == "PLASTIC") {
                      this.$searchSupplierPlastic(this, true).then(vueInstance => {
                        vueInstance.quotationPlasticModel = true
                        vueInstance.toggleLoading(false)
                      })
                    }
                  },
                },
              }, params.row.formNo)
            }
          },
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('RFQ_TYPE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 100,
          align: "center",
          render: (h, params) => {
            if (params.row.rfqType) {
              return h("span", {}, params.row.rfqType.description)
            } else {
              return h("span", {}, "")
            }
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('CATEGORY')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "category",
          width: 80,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            let text = this.$t('DELTA_PN') + '<br>' + this.$t('PN_DESCRIPTION')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 150,
          render: (h, params) => {
            let partNo = params.row.partNo != undefined ? params.row.partNo : ""
            let partDesc = params.row.partDesc != undefined ? params.row.partDesc : ""
            let text = partNo + "<br>" + partDesc
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('VENDOR_CODE') + "<br>" + this.$t('OA_VENDOR_NAME')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 159,
          render: (h, params) => {
            let vendorCode = params.row.vendorCode != undefined ? params.row.vendorCode : ""
            let vendorName = params.row.vendorName != undefined ? params.row.vendorName : ""
            let text = vendorCode + "<br>" + vendorName
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('VENDOR_PN')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "vendorPart",
          width: 150,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('QUOTE_DATE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "quoteDate",
          width: 100,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('UNIT_PRICE') + "<br>" + this.$t('CURRENCY')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 100,
          render: (h, params) => {
            let price = params.row.price != undefined ? params.row.price : ""
            let currency = params.row.currency != undefined ? params.row.currency : ""
            let text = price + "<br>" + currency
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          }
        },
        {
          renderHeader: (h, params) => {
            let text = this.$t('TARGET') + '<br>' + this.$t('PRICE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "targetPrice",
          width: 80,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('RFQ_NO')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "rfqNo",
          width: 100,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('APPROVE_DATE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "approveDate",
          width: 100,
          align: "center",
        }
      ],
      toolingQuotationColumnList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t('FORM_NO')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 160,
          align: "center",
          render: (h, params) => {
            return h("a", {
              attrs: { style: "color:#46A3FF" },
              on: {
                click: () => {
                  this.toolingQuotationType = params.row.toolingQuotationType
                  this.uuid = params.row.uuid
                  this.formNo = params.row.formNo
                  this.toggleLoading(true)
                  this.$searchSupplierTooling(this).then(vueInstance => {
                    vueInstance.toolingModel = true
                    vueInstance.toggleLoading(false)
                  })
                }
              },
            }, params.row.formNo)
          },
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('RFQ_TYPE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 100,
          align: "center",
          render: (h, params) => {
            if (params.row.rfqType) {
              return h("span", {}, params.row.rfqType.description + '(' + params.row.toolingQuotationType + ')')
            } else {
              return h("span", {}, "")
            }
          }
        },
        {
          renderHeader: (h, params) => {
            let text = this.$t('TOOLING_ID')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 150,
          render: (h, params) => {
            return h('div', {
              domProps: {
                innerHTML: params.row.partNo
              }
            })
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('VENDOR_CODE') + "<br>" + this.$t('OA_VENDOR_NAME')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 159,
          render: (h, params) => {
            let vendorCode = params.row.vendorCode != undefined ? params.row.vendorCode : ""
            let vendorName = params.row.vendorName != undefined ? params.row.vendorName : ""
            let text = vendorCode + "<br>" + vendorName
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('QUOTE_DATE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "quoteDate",
          width: 100,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('UNIT_PRICE') + "<br>" + this.$t('CURRENCY')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 100,
          render: (h, params) => {
            let price = params.row.price != undefined ? params.row.price : ""
            let currency = params.row.currency != undefined ? params.row.currency : ""
            let text = price + "<br>" + currency
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          }
        },
        {
          renderHeader: (h, params) => {
            let text = this.$t('TARGET') + '<br>' + this.$t('PRICE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "targetPrice",
          width: 80,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('RFQ_NO')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "rfqNo",
          width: 100,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('APPROVE_DATE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "approveDate",
          width: 100,
          align: "center",
        }
      ],
      quotationGroupColumnList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t('GROUP_KEY');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "groupId",
          width: 150,
          align: "center",
          render: (h, params) => {
            return h("a", {
              attrs: { style: "color:#46A3FF" },
              on: {
                click: () => {
                  this.setHistoryReportGroupId(params.row.groupId)
                  this.$router.push({ name: "RFQ_QUOTATION_HISTORY_REPORT" })
                },
              },
            }, params.row.groupId)
          },
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('VENDOR_CODE');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 150,
          align: "center",
          render: (h, params) => {
            let html = "";
            params.row.quotations.forEach(quotaion => {
              if (quotaion.vendorCode) {
                html += "<lable>" + quotaion.vendorCode + "</lable> <br/>";
              }
            })
            return h("div", {
              domProps: {
                innerHTML: html
              }
            });
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('OA_VENDOR_NAME');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 250,
          align: "center",
          render: (h, params) => {
            let html = "";
            params.row.quotations.forEach(quotaion => {
              if (quotaion.vendorName) {
                html += "<lable>" + quotaion.vendorName + "</lable> <br/>";
              }
            })
            return h("div", {
              domProps: {
                innerHTML: html
              }
            });
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('PLANT_CODE');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 250,
          align: "center",
          render: (h, params) => {
            let html = "";
            params.row.quotations.forEach(quotaion => {
              if (quotaion.plant) {
                html += "<lable>" + quotaion.plant + "</lable> <br/>";
              }
            })
            return h("div", {
              domProps: {
                innerHTML: html
              }
            });
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('CURRENCY');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 250,
          align: "center",
          render: (h, params) => {
            let html = "";
            params.row.quotations.forEach(quotaion => {
              if (quotaion.currency) {
                html += "<lable>" + quotaion.currency + "</lable> <br/>";
              }
            })
            return h("div", {
              domProps: {
                innerHTML: html
              }
            });
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('QUOTE_DATE');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 250,
          align: "center",
          render: (h, params) => {
            let html = "";
            params.row.quotations.forEach(quotaion => {
              if (quotaion.quoteDate) {
                html += "<lable>" + quotaion.quoteDate + "</lable> <br/>";
              }
            })
            return h("div", {
              domProps: {
                innerHTML: html
              }
            });
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('APPROAPPROVE_DATEVE');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 250,
          align: "center",
          render: (h, params) => {
            let html = "";
            params.row.quotations.forEach(quotaion => {
              if (quotaion.quoteDate) {
                html += "<lable>" + quotaion.quoteDate + "</lable> <br/>";
              }
            })
            return h("div", {
              domProps: {
                innerHTML: html
              }
            });
          }
        },
      ],
    }
  },
  methods: {
    ...mapGetters(["getUserProfile", "getLanguage", "getHistoryReportRfqType", "getHistoryReportDeltaPn", "getHistoryReportVendorCode", "getHistoryReportVendorPn",
      "getHistoryReportQuoteFromDate", "getHistoryReportQuoteToDate", "getHistoryReportApproveFromDate", "getHistoryReportApproveToDate", "getModalSize", "getWindowsWidth",
      "getHistoryReportCategory"]),
    ...mapActions(["toggleLoading", "setQuotationList", "setSupplierQuotationId", "setSupplierFormNo", "setHistoryReportRfqType", "setHistoryReportDeltaPn", "setHistoryReportVendorCode", "setHistoryReportVendorPn",
      "setHistoryReportQuoteFromDate", "setHistoryReportQuoteToDate", "setHistoryReportApproveFromDate", "setHistoryReportApproveToDate", "setHistoryReportGroupId",
      "setHistoryReportCategory"]),
    moreDeltaPn() {
      this.deltaPnModel = true
    },
    moreVendorPn() {
      this.vendorPnModel = true
    },
    moreVendorCode() {
      this.vendorCodeModel = true
    },
    confirmDeltaPnModel() {
      this.deltaPnValue.split('\n').forEach(a => {
        this.setHistoryReportDeltaPn(this.getHistoryReportDeltaPn().concat(a.trim() + ";"))
      })
      this.setHistoryReportDeltaPn(this.getHistoryReportDeltaPn().substr(0, this.getHistoryReportDeltaPn().length - 1))
    },
    confirmVendorPnValue() {
      this.vendorPnValue.split('\n').forEach(a => {
        this.setHistoryReportVendorPn(this.getHistoryReportVendorPn().concat(a.trim() + ";"))
      })
      this.setHistoryReportVendorPn(this.getHistoryReportVendorPn().substr(0, this.getHistoryReportVendorPn().length - 1))
    },
    confirmVendorCodeValue() {
      this.vendorCodeValue.split('\n').forEach(a => {
        this.setHistoryReportVendorCode(this.getHistoryReportVendorCode().concat(a.trim() + ";"))
      })
      this.setHistoryReportVendorCode(this.getHistoryReportVendorCode(0).substr(0, this.getHistoryReportVendorCode().length - 1))
    },
    changePage(page) {
      this.pageObj.page = page - 1
      this.search(false)
    },
    changeGroupPage(page) {
      this.groupPageObj.page = page - 1
      this.search(false)
    },
    search(init) {
      const vueInstance = this
      if (init) {
        vueInstance.pageObj = {
          "page": 0,
          "totalPage": 0,
          "totalCount": 0,
          "pageSize": 20
        }
        vueInstance.groupPageObj = {
          "page": 0,
          "totalPage": 0,
          "totalCount": 0,
          "pageSize": 20
        }
      }
      vueInstance.toggleLoading(true)
      vueInstance.quotationList = []
      if (vueInstance.rfqType === "RFQ") {
        vueInstance.$queryQuotationMasterGroup(vueInstance, buildCriteria(vueInstance), "history-report", vueInstance.pageObj).then(data => {
          vueInstance.toggleLoading(false)
          if (data) {
            vueInstance.quotationGroupList = data._embedded.historyGroupQuotationSearchResourceList
            console.log(vueInstance.quotationGroupList)
            vueInstance.groupPageObj = {
              "page": data.page.number + 1,
              "totalPage": data.page.totalPages,
              "totalCount": data.page.totalElements,
              "pageSize": data.page.size
            }
          } else {
            vueInstance.toggleLoading(false)
            vueInstance.$Notice.success({
              title: Translate("COMMON_MESSAGE_INFO"),
              desc: Translate("COMMON_MESSAGE_INFO"),
              render: h => {
                return h('span', [
                  Translate("COMMON_TEXT_NOTHING")
                ])
              }
            });
          }
        })
      } else {
        vueInstance.$queryQuotationMaster(vueInstance, buildCriteria(vueInstance), "history-report", vueInstance.pageObj).then(data => {
          vueInstance.toggleLoading(false)
          if (data) {
            vueInstance.quotationList = data._embedded.quotationHistoryReportDtoResourceList
            vueInstance.pageObj = {
              "page": data.page.number + 1,
              "totalPage": data.page.totalPages,
              "totalCount": data.page.totalElements,
              "pageSize": data.page.size
            }
          } else {
            vueInstance.toggleLoading(false)
            vueInstance.$Notice.success({
              title: Translate("COMMON_MESSAGE_INFO"),
              desc: Translate("COMMON_MESSAGE_INFO"),
              render: h => {
                return h('span', [
                  Translate("COMMON_TEXT_NOTHING")
                ])
              }
            });
          }
        })
      }
    },
    download() {
      this.$downloadExcel(this, "history-report", buildCriteria(this), "")
    },
    downloadAttachment(row) {
      this.$downloadAttachment(this, row.uuid)
    },
    clear() {
      this.setHistoryReportRfqType('COMPONENT')
      this.setHistoryReportDeltaPn('')
      this.setHistoryReportVendorCode('')
      this.setHistoryReportVendorPn('')
      this.setHistoryReportQuoteFromDate('')
      this.setHistoryReportQuoteToDate('')
      this.setHistoryReportApproveFromDate('')
      this.setHistoryReportApproveToDate('')
      this.setHistoryReportCategory('ALL')
    },
  },
  computed: {
    existedQuotationList() {
      return this.quotationList && this.quotationList.length > 0
    },
    existedQuotationGroupList() {
      return this.quotationGroupList && this.quotationGroupList.length > 0
    },
    showCategory() {
      return this.rfqType == 'COMPONENT'
    },
    rfqType: {
      get() {
        return this.getHistoryReportRfqType()
      },
      set(value) {
        this.quotationList = []
        return this.setHistoryReportRfqType(value)
      }
    },
    partNo: {
      get() {
        return this.getHistoryReportDeltaPn()
      },
      set(value) {
        this.quotationList = []
        return this.setHistoryReportDeltaPn(value.trim())
      }
    },
    vendorPn: {
      get() {
        return this.getHistoryReportVendorPn()
      },
      set(value) {
        this.quotationList = []
        return this.setHistoryReportVendorPn(value.trim())
      }
    },
    vendorCode: {
      get() {
        this.quotationList = []
        return this.getHistoryReportVendorCode()
      },
      set(value) {
        this.quotationList = []
        return this.setHistoryReportVendorCode(value.trim())
      }
    },
    fromQuoteDate: {
      get() {
        return this.getHistoryReportQuoteFromDate()
      },
      set(value) {
        this.quotationList = []
        return this.setHistoryReportQuoteFromDate(value)
      }
    },
    toQuoteDate: {
      get() {
        return this.getHistoryReportQuoteToDate()
      },
      set(value) {
        this.quotationList = []
        return this.setHistoryReportQuoteToDate(value)
      }
    },
    approveFromDate: {
      get() {
        return this.getHistoryReportApproveFromDate()
      },
      set(value) {
        this.quotationList = []
        return this.setHistoryReportApproveFromDate(value)
      }
    },
    approveToDate: {
      get() {
        return this.getHistoryReportApproveToDate()
      },
      set(value) {
        this.quotationList = []
        return this.setHistoryReportApproveToDate(value)
      }
    },
    category: {
      get() {
        return this.getHistoryReportCategory()
      },
      set(value) {
        this.quotationList = []
        return this.setHistoryReportCategory(value)
      }
    },
    modalSize() {
      return this.getModalSize()
    },
    windowWidth() {
      return this.getWindowsWidth() - 50
    }
  }
}

function buildCriteria(vueInstance) {
  let deltaPnArray = []
  vueInstance.getHistoryReportDeltaPn().split(';').forEach(a => {
    deltaPnArray.push(a)
  })

  let vendorPnArray = []
  vueInstance.getHistoryReportVendorPn().split(';').forEach(a => {
    vendorPnArray.push(a)
  })

  let vendorCodeArray = []
  vueInstance.getHistoryReportVendorCode().split(';').forEach(a => {
    vendorCodeArray.push(a)
  })
  return {
    "rfqType": vueInstance.getHistoryReportRfqType(),
    "deltaPartNos": vueInstance.getHistoryReportDeltaPn() == "" ? [] : deltaPnArray,
    "vendorPartNos": vueInstance.getHistoryReportVendorPn() == "" ? [] : vendorPnArray,
    "vendorCodes": vueInstance.getHistoryReportVendorCode() == "" ? [] : vendorCodeArray,
    "fromQuoteDate": vueInstance.getHistoryReportQuoteFromDate() == "" ? null : moment(vueInstance.getHistoryReportQuoteFromDate()).format('YYYY-MM-DD'),
    "toQuoteDate": vueInstance.getHistoryReportQuoteToDate() == "" ? null : moment(vueInstance.getHistoryReportQuoteToDate()).format('YYYY-MM-DD'),
    "fromApproveDate": vueInstance.getHistoryReportApproveFromDate() == "" ? null : moment(vueInstance.getHistoryReportApproveFromDate()).format('YYYY-MM-DD'),
    "toApproveDate": vueInstance.getHistoryReportApproveToDate() == "" ? null : moment(vueInstance.getHistoryReportApproveToDate()).format('YYYY-MM-DD'),
    "category": vueInstance.getHistoryReportCategory() == "ALL" || vueInstance.rfqType == 'COMPONENT' ? null : vueInstance.getHistoryReportCategory()
  }
}
</script>

<style scoped></style>
